import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { paths } from 'business-dashboard/src/constants';
import Empty from '../../img/icon-empty-screen';
import PrimaryButton from '../buttons/PrimaryButton';
import { userIsHbs } from '../findUserType';
import styles from './NoContent.module.scss';

type Props = {
    noContentText: string;
    link?: string;
    linkText?: string;
    hasLocations?: boolean;
};
const NoContent = ({ noContentText, link, linkText, hasLocations }: Props): React.ReactElement => {
    const { t: txt } = useTranslation();
    const userHbs = userIsHbs();
    const navigate = useNavigate();
    const redirectToAddBuilding = (): void => {
        navigate({ pathname: `/${paths.addBuilding}` });
    };

    if (userHbs && hasLocations === false) {
        return (
            <div className={styles.page} data-buildings-no-content>
                <h2 className={styles.header}>{txt('WelcomeToAirthingsForBusiness')}</h2>
                <Empty className={styles.icon} />
                <p className={styles.text}>{txt('Business.AddBuilding')}</p>
                <div className={styles.text}>
                    <PrimaryButton
                        testAttr="add-building-button"
                        onClick={redirectToAddBuilding}
                        color="primary"
                        title="Building.AddBuilding"
                    />
                </div>
            </div>
        );
    }
    return (
        <div className={styles.page}>
            <Empty className={styles.icon} />
            <p className={styles.title}>{txt('NoContent')}</p>
            {link && linkText ? (
                <p className={styles.linkText}>
                    {txt('Click')} <Link to={link}>{txt(linkText)}</Link> {txt(noContentText)}
                </p>
            ) : (
                <p className={styles.thinText}>{txt(noContentText)}</p>
            )}
        </div>
    );
};

export default NoContent;
